import axios from 'axios';
import { captureException } from '@sentry/react';

import { clickPlace } from 'pushEvent/constants';
import pushEvent, {
  EVENT_PRODUCT_DETAILS_SUCCESS_OUT_OF_STOCK_FORM,
  EVENT_PRODUCT_DETAILS_VIEW_OUT_OF_STOCK_FORM,
} from 'pushEvent/index';
import {
  OUT_OF_STOCK_FORM_VIEW,
  OUT_OF_STOCK_POPUP_STATE_OPEN,
} from 'store/Favorites/outofstock/constants';

import { getProductArticle, getProductId } from '../selectors';
import {
  ERROR_CLASSNAME,
  INFO_CLASSNAME,
  LOCAL_STORAGE_DATA_KEY,
  OUT_OF_STOCK_FORM_SUCCESS,
  STATUS_FAIL_EMOJI,
  SUBSCRIBED_TO_PRODUCT,
  TOOGLE_AGREEMENT_FIELD_DATA,
  UP_EMOJI,
} from './constants';
import { getOutOfStockErrorText, getOutOfStockSuccessText } from './selectors';

export const toggleAgreementCheckbox = (value) => (dispatch) => {
  dispatch({
    payload: value,
    type: TOOGLE_AGREEMENT_FIELD_DATA,
  });
};

export const subscribeOutOfStockСardProduct = () => (dispatch, getState) => {
  const state = getState();
  const message = getOutOfStockSuccessText(state);
  const emoji = UP_EMOJI;
  const className = INFO_CLASSNAME;

  dispatch({
    className,
    emoji,
    message,
    type: SUBSCRIBED_TO_PRODUCT,
  });
};

export const errorOutOfStockСardProduct = () => (dispatch, getState) => {
  const state = getState();
  const message = getOutOfStockErrorText(state);
  const emoji = STATUS_FAIL_EMOJI;
  const className = ERROR_CLASSNAME;

  dispatch({
    className,
    emoji,
    message,
    type: SUBSCRIBED_TO_PRODUCT,
  });
};

export const hideOutOfStockСardForm = () => ({
  isOpened: false,
  type: OUT_OF_STOCK_FORM_SUCCESS,
});
export const openOutOfStockPopup = (productId, article) => (dispatch) => {
  dispatch({
    article,
    outOfStockOpenState: true,
    productId,
    type: OUT_OF_STOCK_POPUP_STATE_OPEN,
    viewState: OUT_OF_STOCK_FORM_VIEW,
  });
};

export const onOpenOutOfStockForm = (key, value) => () => {
  // YM
  pushEvent(EVENT_PRODUCT_DETAILS_VIEW_OUT_OF_STOCK_FORM, { [key]: value });
};

export const sendAntiforgeryRequest = (onSuccess, onError) => {
  axios({
    data: null,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
    method: 'post',
    responseType: 'json',
    url: '/shop/basket/antiforgeryrequestjson/',
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((error) => {
      captureException(error);
      onError(error);
    });
};

export const submitOutOfStockProductForm = (data) => (dispatch, getState) => {
  const state = getState();
  const { callback, email, name: fullname } = data;
  const productId = getProductId(state);
  const article = getProductArticle(state);
  const onError = () => {
    // Ошибка при подписке на поступление товара
    dispatch(errorOutOfStockСardProduct());
  };
  sendAntiforgeryRequest((antiforgeryData) => {
    const { _RequestVerificationToken } = antiforgeryData.data || {};
    axios({
      data: {
        article,
        email,
        fullname,
      },
      headers: {
        __RequestVerificationToken: _RequestVerificationToken,
        'X-Requested-With': 'XMLHttpRequest',
      },
      method: 'post',
      responseType: 'json',
      url: '/shop/admission/',
    })
      .then((response) => {
        const responseData = response.data || {};

        if (responseData.IsSucceeded) {
          dispatch(hideOutOfStockСardForm());
          dispatch(subscribeOutOfStockСardProduct());

          setProductIdInStorage(productId);
          // YM
          pushEvent(EVENT_PRODUCT_DETAILS_SUCCESS_OUT_OF_STOCK_FORM, {
            [clickPlace.PDP]: productId,
          });

          if (callback) {
            callback();
          }
        } else {
          onError();
        }
      })
      .catch(onError);
  }, onError);
};

export const setProductIdInStorage = (productId) => {
  const storage = (window || {}).localStorage;

  const outofstockList = JSON.parse(storage.getItem(LOCAL_STORAGE_DATA_KEY)) || [];
  outofstockList.push(productId);
  storage.setItem(LOCAL_STORAGE_DATA_KEY, JSON.stringify(outofstockList));
};

export const getSubscribeProductIdsFromStorage = () => {
  const storage = (window || {}).localStorage;

  const list = JSON.parse(storage.getItem(LOCAL_STORAGE_DATA_KEY));

  return list ?? [];
};
